'use client'

import 'swiper/css'
import 'swiper/css/navigation'

import { BsCalendar3Week } from 'react-icons/bs'
import { PiPersonSimpleHike } from 'react-icons/pi'
import { useEffect, useState } from 'react'
import { getImageUrl, sendRequest } from '@/lib/api-service'

interface WeekSchedule {
	day: string
	title: string
	description: string
	image: string
}

export default function WeekSection({ weekImages, weekIntro }: {weekImages: string[], weekIntro:string}) {
	const [weeks, setWeeks] = useState<WeekSchedule[]>([]);

	useEffect(() => {
		const fetchWeeks = async () => {
			const response = await sendRequest('GET', '/week-schedules/', true);
			if (response ) {
				setWeeks(response);
			}
		};
		fetchWeeks();
	}, []);

	return (
		<div className='relative bg-white pb-6 overflow-hidden'>
			<BsCalendar3Week className="absolute top-[20px] left-[20px] w-40 h-40 sm:w-64 sm:h-64 text-mountain-900 opacity-10 pointer-events-none z-0" />
			<PiPersonSimpleHike className="absolute bottom-[0px] right-[0px] w-40 h-40 sm:w-64 sm:h-64 text-mountain-900 opacity-10 pointer-events-none z-0" />

			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-6 relative z-10'>
				<h1 className="text-4xl lg:text-5xl drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 mb-4 uppercase text-center">
					Зуслангийн өдрүүд хэрхэн өнгөрдөг вэ?
				</h1>
				<div className='mb-12 text-center text-xl text-mountain-900 font-semibold'>
					<span dangerouslySetInnerHTML={{ __html: weekIntro }} />
				</div>

				<div className='flex flex-col lg:flex-row gap-12'>
					<div className="xl:w-1/2 space-y-8 lg:space-y-12">
						{[...weeks]
							.sort((a, b) => a.day.localeCompare(b.day))
							.map((item, index) => (
							<div key={index}>
								<div className="flex items-center gap-4">
									{item.image &&
									<img
										src={getImageUrl(item.image)}
										alt={item.day}
										className="w-16 h-16 object-cover"
									/>
									}
									<div>
										<h2 className="text-2xl text-mountain-900 font-bold">{item.day}</h2>
										<span className="text-lg text-mountain-900">{item.title}: </span>
										<span className='ms-2'>{item.description}</span>
									</div>
								</div>
							</div>
						))}
					</div>
					<div className='relative xl:w-1/2 hidden xl:flex justify-center items-center'>
						<div className="relative w-full h-[1050px]">
							{weekImages && weekImages.map((image, index) => {
								const isLeft = index % 2 === 0
								const top = 150 * index + 20 * index // vertical offset
								return (
									<img
										key={index}
										src={image}
										className={`
											absolute
											${isLeft ? 'left-0' : 'right-0'}
											top-[${top}px]
											w-[400px] h-[300px]
											object-cover rounded-3xl shadow-xl
											z-[10] transition-transform duration-300
											hover:scale-105 hover:z-[12]
										`}
										alt={`Camp ${index + 1}`}
										style={{ top: `${top}px` }}
									/>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
